export default function displayZoningInfo(results) {
    let s = "<h3>Zoning Info</h3>"; 
    let displayedValues = []; 
    if (results?.features)
    {
        s += "<table>"
        for( let i = 0; i < results.features.length ; i++) {
            for (const [key, value] of Object.entries(results.features[i].attributes)) {
                if (!displayedValues.includes(value))
                {
                    s += `<tr><td><b>${key}:</b> ${value}</tr></td>`; 
                    displayedValues.push(value); 
    
                }
            }
        
        }
        s += "</table>"; 
    }
    else if (results)
    {   
        s += "<table>"
        for( let i = 0; i < results.length ; i++) {
            for (const [key, value] of Object.entries(results[i].attributes)) {
                if (!displayedValues.includes(value))
                {
                    s += `<tr><td><b>${key}:</b> ${value}</tr></td>`; 
                    displayedValues.push(value); 
    
                }
            }
        
        }
        s += "</table>"; 

    }
    else {
        s += "<p>No zoning data found.</p>"
    }
    return s;
}
